import {
  TransactionStatus,
  TransactionType,
} from 'src/models/transaction.models'
import { GetCreditCardsRequest } from 'src/requests/getCreditCards.request'
import { GetVirtualCardsRequest } from 'src/requests/getVirtualCards.request'

export enum StatisticModelType {
  CreditCard = 'CREDIT_CARD',
  VirtualCard = 'VIRTUAL_CARD',
  Transaction = 'TRANSACTION',
}

export enum StatisticAggregateType {
  Count = 'COUNT',
  Sum = 'SUM',
}

export enum TransactionStatisticQueryFieldType {
  transactionBillingAmountCents = 'TRANSACTION_BILLING_AMOUNT_CENTS',
  clearingBillingAmountCents = 'CLEARING_BILLING_AMOUNT_CENTS',
}

export interface VirtualCardStatisticRequest {
  agg: StatisticAggregateType
  type: StatisticModelType.VirtualCard
  query: GetVirtualCardsRequest
}

export interface CreditCardStatisticRequest {
  agg: StatisticAggregateType
  type: StatisticModelType.CreditCard
  query: GetCreditCardsRequest
}

export interface TransactionStatisticRequest {
  agg: StatisticAggregateType
  type: StatisticModelType.Transaction
  query: {
    virtualCardId: string[]
    type: TransactionType
    field: TransactionStatisticQueryFieldType
    status: TransactionStatus[]
  }
}

export type StatisticRequest =
  | VirtualCardStatisticRequest
  | CreditCardStatisticRequest
  | TransactionStatisticRequest

export interface StatisticsRequest {
  statistics: StatisticRequest[]
}
